import { AnoBase } from './ano-base.model';

export class UsuarioAutenticado {

  login: string;
  nome: string;
  idUnico: number;
  idMomento: number;
  icEstrangeiro: boolean;

  constructor(init?: Partial<UsuarioAutenticado>) {
    Object.assign(this, init);
  }
}
